<template>
  <div class="yh_harvest">
    <section class="harvest_banner">
      <div class="harvest_search_box harvest_search_box_else_width" id="harvest_search_box1">
        <!-- <div class="hot_word">
          <router-link to="/hot">2018热词</router-link>
        </div> -->
        <h4 class="form_h4">【基金成果库】</h4>
        <el-form ref="form" label-width="62px" class="form_qq">
          <el-form-item label="成果类型" class="harvest_param">
            <el-select v-model="form.categoryId" placeholder="请选择成果类型" class="topic_type_else">
              <el-option
                v-for="x in categoryId_arr"
                :label="x.label"
                :value="x.value"
                :key="x.label"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="书名" class="harvest_param">
            <el-input placeholder="请输入" v-model="form.name" class="topic_type_else"></el-input>
          </el-form-item>
          <el-form-item label="作者" class="harvest_param left">
            <el-input placeholder="请输入" v-model="form.author" class="harvest_inp"></el-input>
          </el-form-item>
          <el-form-item label="推荐单位" class="harvest_param right">
            <el-input placeholder="请输入" v-model="form.recommendOrganization" class="harvest_inp"></el-input>
          </el-form-item>
          <el-form-item label="出版单位" class="harvest_param left">
            <el-input placeholder="请输入" v-model="form.publishHouse" class="harvest_inp"></el-input>
          </el-form-item>
          <el-form-item label="出版时间" class="harvest_param right">
            <el-date-picker
              class="harvest_inp"
              value-format="yyyy-MM-dd"
              v-model="form.publish_time"
              type="daterange"
              range-separator="至"
              start-placeholder
              end-placeholder
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div class="harest_btn_box" style="padding-left: 62px;">
          <el-button type="primary" class="harvest_btn" @click="search">搜索</el-button>
          <el-button class="harvest_btn gray_btn" @click="reset_fn">重置</el-button>
        </div>
      </div>
    </section>
    <section class="harvest_tab_box">
      <div class="width1000">
        <el-table :data="tab_list" class="width1000" width="1000">
          <el-table-column label="序号" type="index" :index="indexMethod" width="50"></el-table-column>
          <el-table-column prop="name" label="书名"></el-table-column>
          <el-table-column prop="author" label="作者"></el-table-column>
          <el-table-column prop="recommendOrganization" label="推荐单位"></el-table-column>
          <el-table-column prop="publishHouse" label="出版单位"></el-table-column>
          <el-table-column prop="publishTime" width="90" label="出版时间"></el-table-column>
          <el-table-column prop="visits" width="60" label="阅读数"></el-table-column>
          <el-table-column fixed="right" width="90" label="操作">
            <template slot-scope="scope">
              <span @click.prevent="to_detial(scope.row.id)" class="msg_btn pointer">查看详情</span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          class="mid"
          background
          :page-size="num_s"
          layout="prev, pager, next"
          @current-change="get_page"
          v-show="data_len > 0"
          :total="data_len"
        ></el-pagination>
      </div>
    </section>
  </div>
</template>

<script>
import { yh_post } from "../../api";
import { fn_pos_mid } from "../../assets/js/harvest";
import { sort_arr, get_date } from "../../assets/js/public";
export default {
  data() {
    return {
      form: {
        categoryId: 0,
        name: "",
        author: "",
        recommendOrganization: "",
        publishHouse: "",
        publish_time: ""
      },
      tab_data: [],
      categoryId_arr: [
        {
          value: 0,
          label: "全部"
        },
        {
          value: 1,
          label: "常规资助书目"
        },
        {
          value: 2,
          label: "重点资助书目"
        }
      ],
      current_page: 1,
      tab_list: [],
      data_len: 0, //数据总数
      num_s: 10
    };
  },
  methods: {
    indexMethod(index) {
      return  ((this.current_page -1) * 10) + index + 1;
    },
    search() {
      this.current_page = 1;
      this.search_fn();
    },
    open(txt) {
      this.$alert(txt, "温馨提示", {
        confirmButtonText: "确定"
      });
    },
    get_tab_fn() {
      var arr = require("../../assets/top.json");
      this.data_len = arr.length;
      this.tab_list = sort_arr(arr, this.num_s);
      this.page_all = this.tab_list.length;
      this.$api.axios_social_sciences2(this.form).then(res => {
        this.tab_data = res.data;
        this.data_len = this.tab_data.length;
        this.tab_list = sort_arr(this.tab_data, this.num_s);
      });
    },
    check_fn() {
      return true;
    },
    search_fn() {
      var url = "?size=10&page=" + this.current_page;
      if (this.form.categoryId != 0) {
        var str = "&categoryId=" + this.form.categoryId;
        url += str;
      } else {
        url += "";
      }
      if (this.form.name != "") {
        var reg = new RegExp("[`~\":;'<>]");
      if(reg.test(this.form.name)){
        this.$message.error("成果名称不能包含\" : ; ' < >等特殊字符");
        return;
      }
        var str = "&name=" + this.form.name;
        url += str;
      } else {
        url += "";
      }
      if (this.form.author != "") {
        var reg1 = new RegExp("[`~\":;'<>]");
        if(reg1.test(this.form.author)){
        this.$message.error("作者不能包含\" : ; ' < >等特殊字符");
        return;
      }
        var str = "&author=" + this.form.author;
        url += str;
      } else {
        url += "";
      }

      if (this.form.recommendOrganization != "") {
        var reg2 = new RegExp("[`~\":;'<>]");
        if(reg2.test(this.form.recommendOrganization)){
        this.$message.error("推荐单位不能包含\" : ; ' < >等特殊字符");
        return;
      }
        var str = "&recommendOrganization=" + this.form.recommendOrganization;
        url += str;
      } else {
        url += "";
      }
      if (this.form.publishHouse != "") {
        var reg3 = new RegExp("[`~\":;'<>]");
        if(reg3.test(this.form.publishHouse)){
        this.$message.error("出版单位不能包含\" : ; ' < >等特殊字符");
        return;
      }
        var str = "&publishHouse=" + this.form.publishHouse;
        url += str;
      } else {
        url += "";
      }
      if (this.form.publish_time != "") {
        var d1 = get_date(new Date(this.form.publish_time[0]));
        var d2 = get_date(new Date(this.form.publish_time[1]));
        var str = "&startTime=" + d1 + "&endTime=" + d2;
        url += str;
        console.log(str);
      } else {
        url += "";
      }
      console.log(this.form);
      console.log(this.form.publish_time);
      this.$api.axios_fund(url).then(res => {
        if (res.status === "OK") {
          this.tab_list = res.result.items;
          this.data_len = res.result.total;
        }else if(res.status==="FAIL"){
            if(res.errors[0].code === 1014){
          this.$message.error("登录过期，请重新登录");
          this.$router.push({ path: "/login" });
        }
        else if(res.errors[0].code === 1017){
          this.$message.error("您的账号已在其他地方登录，若不是本人操作，请注意账号安全");
          this.$router.push({ path: "/login" });
        }
        else{
          this.$message.error("数据请求错误");
        }
          }
      });
    },
    reset_fn() {
      this.form = {
        categoryId: "",
        name: "",
        author: "",
        recommendOrganization: "",
        publishHouse: "",
        publish_time: ""
      };
    },
    to_detial(id) {
      this.$router.push({
        path: "/fund_details",
        query: {
          id: id
        }
      });
    },
    get_page(d) {
      this.current_page = d;
      this.search_fn();
    }
  },
  mounted() {
    fn_pos_mid("harvest_search_box1");
    // 默认查询一次
    this.search_fn();
  },
  updated() {
    fn_pos_mid("harvest_search_box1");
  },
  watch: {},
  created: function() {
    if (localStorage.getItem("doc_token") == null) {
      this.$router.push({ path: "/login" });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("../../assets/css/else.css");
@import url("../../assets/css/harvest.css");
</style>



// WEBPACK FOOTER //
// src/components/harvest/fund.vue